import { PayPalButtons } from "@paypal/react-paypal-js";
import axios from "../api/axiosPublic";

export default function PaypalTest() {

  // 👉 ID DE INSCRIPCIÓN DE PRUEBA
  // (usa uno que exista en tu BD)
  const inscripcionId = 1;

  return (
    <div style={{ maxWidth: 400, margin: "50px auto" }}>
      <h2>PayPal Sandbox (Backend conectado)</h2>

      <PayPalButtons
        style={{ layout: "vertical" }}

        // 1️⃣ Crear orden en backend
        createOrder={async () => {
          const res = await axios.post("/paypal/create-order", {
            inscripcionId
          });
          return res.data.orderId;
        }}

        // 2️⃣ Capturar pago en backend
        onApprove={async (data) => {
          await axios.post("/paypal/capture-order", {
            orderId: data.orderID,
            inscripcionId
          });

          alert("Pago aprobado y guardado (sandbox)");
        }}

        onError={(err) => {
          console.error("PayPal error:", err);
          alert("Error en PayPal");
        }}
      />
    </div>
  );
}
